import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36af3f3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Usage-container" }
const _hoisted_2 = { class: "d-flex flex-column flex-md-row justify-content-md-between" }
const _hoisted_3 = { class: "d-flex flex-column flex-sm-row col-md-6 mt-2 mt-md-0" }
const _hoisted_4 = { style: {"width":"250px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Displaying reports for:", -1))
const _hoisted_6 = { class: "ms-sm-2 mt-2 mt-sm-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Group by:", -1))
const _hoisted_8 = { class: "d-flex flex-column flex-sm-row col-md-6 justify-content-md-end mt-2 mt-md-0" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Filter by Room:", -1))
const _hoisted_11 = {
  key: 1,
  class: "ms-sm-2 mt-2 mt-sm-0"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block" }, "Filter by Location:", -1))
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-lg-6 p-0 pe-lg-3 mt-4 graph-container" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "col-lg-6 p-0 ps-lg-3 mt-4 graph-container" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-lg-6 p-0 pe-lg-3 mt-4 mb-lg-4 graph-container" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "col-lg-6 p-0 ps-lg-3 mt-4 mb-4 graph-container" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Note"),
  /*#__PURE__*/_createTextVNode(": Reports display example data during trials.")
], -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_UsageStatBarGraph = _resolveComponent("UsageStatBarGraph")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_tooltip, {
            disabled: !_ctx.isTrial,
            content: "Reports display example data during trials."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueDatePicker, {
                disabled: _ctx.isTrial,
                range: "",
                clearable: false,
                modelValue: _ctx.dateRange,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
                position: "left",
                "auto-apply": "",
                "enable-time-picker": false,
                "month-change-on-scroll": false,
                "min-date": _ctx.minDate,
                "max-date": new Date(),
                "prevent-min-max-navigation": "",
                "preset-dates": _ctx.presetValues,
                "multi-calendars": { solo: true },
                "week-start": "0",
                "hide-offset-dates": ""
              }, null, 8, ["disabled", "modelValue", "min-date", "max-date", "preset-dates"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_el_tooltip, {
            disabled: !_ctx.isTrial,
            content: "Reports display example data during trials."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                disabled: _ctx.isTrial,
                modelValue: _ctx.groupBy,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.groupBy) = $event)),
                placeholder: "Select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupings, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value,
                      disabled: !_ctx.groupingAllowed(item.value)
                    }, null, 8, ["label", "value", "disabled"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.roomFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.isTrial,
                content: "Reports display example data during trials."
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    disabled: _ctx.isTrial,
                    modelValue: _ctx.roomSelectionIdx,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.roomSelectionIdx) = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRoomSelectionOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idx,
                          label: item.option,
                          value: item.idx
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.locationFilter)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_el_tooltip, {
                disabled: !_ctx.isTrial,
                content: "Reports display example data during trials."
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    disabled: _ctx.isTrial,
                    modelValue: _ctx.locationSelectionIdx,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.locationSelectionIdx) = $event)),
                    placeholder: "Select"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredLocationSelectionOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idx,
                          label: item.option,
                          value: item.idx,
                          disabled: _ctx.isTrial
                        }, null, 8, ["label", "value", "disabled"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["disabled", "modelValue"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("article", _hoisted_14, [
        _createElementVNode("div", {
          class: _normalizeClass(["dt-container--small d-flex flex-column justify-content-between", { 'dt-container--border' : _ctx.border }])
        }, [
          (_ctx.isTrial && !_ctx.showExampleData)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _hoisted_17))
            : _createCommentVNode("", true),
          _createVNode(_component_UsageStatBarGraph, {
            title: "Total Connections",
            subTitle: "How many times users connected a device with Ditto.",
            height: "400",
            width: "400",
            dataPointStyle: [{label:'Total Connections', backgroundColor:'rgba(0, 168, 135,0.75)', borderColor:'rgba(0, 168, 135,1)'}],
            data: _ctx.charts.totalConnectionData,
            groupBy: _ctx.groupBy,
            loading: _ctx.charts.totalConnectionsLoading,
            enableSumLabel: true,
            trialMode: _ctx.isTrial
          }, null, 8, ["dataPointStyle", "data", "groupBy", "loading", "trialMode"])
        ], 2)
      ]),
      _createElementVNode("article", _hoisted_18, [
        _createElementVNode("div", {
          class: _normalizeClass(["dt-container--small d-flex flex-column justify-content-between", { 'dt-container--border' : _ctx.border }])
        }, [
          (_ctx.isTrial && !_ctx.showExampleData)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _hoisted_21))
            : _createCommentVNode("", true),
          _createVNode(_component_UsageStatBarGraph, {
            title: "Total Mirroring Time",
            subTitle: "The total amount of time all users spent screen mirroring.",
            height: "400",
            width: "400",
            dataPointStyle: [{label:'Total Mirroring Time', backgroundColor:'rgba(0, 168, 135, 0.75)', borderColor:'rgba(0, 168, 135, 1)'}],
            data: _ctx.charts.totalTimeMirroringData,
            groupBy: _ctx.groupBy,
            loading: _ctx.charts.totalTimeMirroringLoading,
            enableSumLabel: true,
            durationType: "seconds",
            trialMode: _ctx.isTrial
          }, null, 8, ["dataPointStyle", "data", "groupBy", "loading", "trialMode"])
        ], 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("article", _hoisted_23, [
        _createElementVNode("div", {
          class: _normalizeClass(["dt-container--small d-flex flex-column justify-content-between", { 'dt-container--border' : _ctx.border }])
        }, [
          (_ctx.isTrial && !_ctx.showExampleData)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _hoisted_26))
            : _createCommentVNode("", true),
          _createVNode(_component_UsageStatBarGraph, {
            title: "Average Time Mirroring",
            subTitle: "The average amount of time each session lasted.",
            height: "400",
            width: "400",
            dataPointStyle: [{label:'Average Time Mirroring', backgroundColor:'rgba(0, 168, 135,0.75)', borderColor:'rgba(0, 168, 135,1)'}],
            data: _ctx.charts.averageTimeMirroringData,
            groupBy: _ctx.groupBy,
            loading: _ctx.charts.averageTimeMirroringLoading,
            durationType: "seconds",
            trialMode: _ctx.isTrial
          }, null, 8, ["dataPointStyle", "data", "groupBy", "loading", "trialMode"])
        ], 2)
      ]),
      _createElementVNode("article", _hoisted_27, [
        _createElementVNode("div", {
          class: _normalizeClass(["dt-container--small d-flex flex-column justify-content-between", { 'dt-container--border' : _ctx.border }])
        }, [
          (_ctx.isTrial && !_ctx.showExampleData)
            ? (_openBlock(), _createElementBlock("p", _hoisted_28, _hoisted_30))
            : _createCommentVNode("", true),
          _createVNode(_component_UsageStatBarGraph, {
            title: "Ditto Connect Usage",
            subTitle: "Compare how users connect: the Ditto Connect webpage vs. the Ditto Connect app.",
            height: "400",
            width: "400",
            dataPointStyle: [{label:'Website', backgroundColor:'rgba(0, 168, 135,0.75)', borderColor:'rgba(0, 168, 135,1)'}, {label:'App', backgroundColor:'rgba(27, 207, 201, 0.75)', borderColor:'rgba(27, 207, 201, 1)'}],
            data: _ctx.charts.dittoConnectUsageData,
            groupBy: _ctx.groupBy,
            loading: _ctx.charts.dittoConnectUsageLoading,
            trialMode: _ctx.isTrial
          }, null, 8, ["dataPointStyle", "data", "groupBy", "loading", "trialMode"])
        ], 2)
      ])
    ])
  ])), [
    [_directive_loading, _ctx.pageLoading]
  ])
}